// src/components/layout/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-800 border-t border-gray-700">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
          <div>
            <Link to="/" className="inline-block mb-6">
              <span className="text-2xl font-bold tracking-tight text-gray-200">PricePatent</span>
            </Link>
            <p className="text-gray-400">
              AI-powered platform for instant patent and company valuations. Get accurate, data-driven insights in seconds.
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase mb-6">Valuation Tools</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/demo" className="text-base text-gray-400 hover:text-blue-400 transition-colors flex items-center group">
                  Try Demo
                  <ArrowRight className="ml-2 h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-base text-gray-400 hover:text-blue-400 transition-colors flex items-center group">
                  Products
                  <ArrowRight className="ml-2 h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase mb-6">Resources</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/sample-report" className="text-base text-gray-400 hover:text-blue-400 transition-colors flex items-center group">
                  Sample Reports
                  <ArrowRight className="ml-2 h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-base text-gray-400 hover:text-blue-400 transition-colors flex items-center group">
                  About
                  <ArrowRight className="ml-2 h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase mb-6">Support</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/contact" className="text-base text-gray-400 hover:text-blue-400 transition-colors flex items-center group">
                  Contact Us
                  <ArrowRight className="ml-2 h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
              <li>
                <a href="mailto:pricepatent@wisdomain.com" className="text-base text-gray-400 hover:text-blue-400 transition-colors">
                  pricepatent@wisdomain.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-base text-gray-500">
              &copy; {new Date().getFullYear()} PricePatent. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0 space-x-4">
              <Link to="/privacy" className="text-sm text-gray-500 hover:text-blue-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-gray-500 hover:text-blue-400 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;